import { Component, OnInit } from "@angular/core";
import { SupportService } from "./support.service";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import {
  NgbModal,
  NgbModalRef,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import Swal from "sweetalert2";
import { ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material";

@Component({
  selector: "app-support-manage",
  templateUrl: "./support-manage.component.html",
  styleUrls: ["./support-manage.component.scss"],
})
export class SupportManageComponent implements OnInit {
  // START - Update driver variable

  isLoading: boolean = false;
  pageLimit: number = 10;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  // end filter
  // profile
  // profile end
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };

  private modalRef: NgbModalRef;

  constructor(
    private SupportService: SupportService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getSupportList();
  }
  queryParams() {
    let query = "";

    if (this.busTitle && this.busTitle !== "") {
      query = query + "text=" + this.busTitle.trim() + "&";
    }
    if (this.busCategory && this.busCategory !== "") {
      query = query + "email=" + this.busCategory.trim() + "&";
    }
    // if (this.status && this.status !== "") {
    //   query = query + "status=" + this.status.trim() + "&";
    // }
    return query;
  }
  // GET USERS (By Default ALL)
  supportList: any;
  getSupportList() {
    let query = this.queryParams();
    this.isLoading = true;
    this.SupportService.getSupportList(query).subscribe(
      (res) => {
        this.isLoading = false;
        //console.log("Response: ", res);
        if ((res["message"] = "Success")) {
          this.supportList = res["data"]["supportList"];
          console.log(this.supportList, "supportList");
          //  this.rows = res["data"]["busList"];
        } else {
          // this.rows = [];
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  busTitle: any;
  busCategory: any;
  status: any;
  onReset() {
    (this.busTitle = ""), (this.busCategory = ""), (this.status = "");
    this.getSupportList();
  }

  showImage(image: any, title: string) {
    Swal.fire({
      title: image,

      customClass: {
        title: "title-class11",
      },
    });
  }
}
